module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded-title"
  }, [_c('b', [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('i', [_vm._v("This book is dedicated to my mother, who I affectionately call The Guru. She gave me life and made it better by teaching me to sew. Every page of this book is influenced by her brilliant ability with needle and thread.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8118b6bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0003_dedication.vue
// module id = 60
// module chunks = 0